import { gql } from "apollo-angular";
import { ADDRESS_FRAGMENT } from "./address-definitions";
import { ASSET_FRAGMENT } from "./asset-definition";
import { BASEMODEL_FRAGMENT } from "./base-definition";
import { CONTACT_FIELDS_FRAGMENT } from "./contact-definitions";
import { DELETION_RESPONSE_FRAGMENT } from "./system-definition";


// region Data Protection
export const DATA_PROTECTION_FIELDS_FRAGMENT = gql`
fragment DataProtectionFields on DataProtection {
    ...IBaseModel
    lastDataProtectionSentAt
    dataProtectionSent
    informationObtainedAt
    originOfInformation
    noDirectAdvertising
    note
    featuredAssetId
    featuredAsset {
        ... Asset
    }
    assets {
        ...Asset
    }
}
${BASEMODEL_FRAGMENT}
${ASSET_FRAGMENT}
`;

export const DATA_PROTECTION_FRAGMENT = gql`
fragment DataProtection on DataProtection {
    ... DataProtectionFields
}
${DATA_PROTECTION_FIELDS_FRAGMENT}
`;

export const GET_DATA_PROTECTIONS = gql`
query GetDataProtections($input:SearchInput) {
    getDataProtections(input: $input) {
        totalItems
        items {
            ...DataProtection
        }
    }
}
${DATA_PROTECTION_FRAGMENT}
`;

export const GET_DATA_PROTECTION = gql`
query GetDataProtection($id:String!) {
    getDataProtection(id: $id) {
        ...DataProtection
    }
}
${DATA_PROTECTION_FRAGMENT}
`;

export const SAVE_DATA_PROTECTION = gql`
mutation SaveDataProtection($input: DataProtectionInput!) {
    saveDataProtection(input: $input){
        ...DataProtection
    }
}
${DATA_PROTECTION_FRAGMENT}
`;

export const DELETE_DATA_PROTECTION = gql`
mutation DeleteDataProtection($id: String!) {
    deleteDataProtection(id: $id) {
        ... DeletionResponse
    }
}
${DELETION_RESPONSE_FRAGMENT}
`;
// endregion

// region Data Protection Notification
export const DATA_PROTECTION_NOTIFICATION_FRAGMENT = gql`
fragment DataProtectionNotification on DataProtectionNotification {
    ...IBaseModel
    dataProtectionSourceId
    dataProtectionSource {
        ...DataProtection
    }
    date
    notificationType
    informedBy
    note
    recipient
}
${BASEMODEL_FRAGMENT}
${DATA_PROTECTION_FRAGMENT}
`;

export const GET_DATA_PROTECTION_NOTIFICATIONS = gql`
query GetDataProtectionNotifications($input:SearchInput) {
    getDataProtectionNotifications(input: $input) {
        totalItems
        items {
            ...DataProtectionNotification
        }
    }
}
${DATA_PROTECTION_NOTIFICATION_FRAGMENT}
`;

export const GET_DATA_PROTECTION_NOTIFICATION = gql`
query GetDataProtectionNotification($id:String!) {
    getDataProtectionNotification(id: $id) {
        ...DataProtectionNotification
    }
}
${DATA_PROTECTION_NOTIFICATION_FRAGMENT}
`;

export const SAVE_DATA_PROTECTION_NOTIFICATION = gql`
mutation SaveDataProtectionNotification($input: DataProtectionNotificationInput!) {
    saveDataProtectionNotification(input: $input){
        ...DataProtectionNotification
    }
}
${DATA_PROTECTION_NOTIFICATION_FRAGMENT}
`;

export const DELETE_DATA_PROTECTION_NOTIFICATION = gql`
mutation DeleteDataProtectionNotification($id: String!) {
    deleteDataProtectionNotification(id: $id) {
        ... DeletionResponse
    }
}
${DELETION_RESPONSE_FRAGMENT}
`;
// endregion

// region Address Data Protection Link
export const ADDRESS_DATA_PROTECTION_LINK_FRAGMENT = gql`
fragment AddressDataProtectionLink on AddressDataProtectionLink {
    ...IBaseModel
    addressId
    address {
        ...Address
    }
    dataProtectionId
    dataProtection {
        ...DataProtection
    }
}
${BASEMODEL_FRAGMENT}
${ADDRESS_FRAGMENT}
${DATA_PROTECTION_FRAGMENT}
`;

export const ADDRESS_DATA_PROTECTION_LINK_WITHOUT_ADRESS_FRAGMENT = gql`
fragment AddressDataProtectionLinkWithoutAddress on AddressDataProtectionLink {
    ...IBaseModel
    addressId
    dataProtectionId
    dataProtection {
        ...DataProtection
    }
}
${BASEMODEL_FRAGMENT}
${DATA_PROTECTION_FRAGMENT}
`;

export const GET_ADDRESS_DATA_PROTECTION_LINKS = gql`
query GetAddressDataProtectionLinks($input:SearchInput) {
    getAddressDataProtectionLinks(input: $input) {
        totalItems
        items {
            ...AddressDataProtectionLink
        }
    }
}
${ADDRESS_DATA_PROTECTION_LINK_FRAGMENT}
`;

export const GET_ADDRESS_DATA_PROTECTION_LINK = gql`
query GetAddressDataProtectionLink($id:String!) {
    getAddressDataProtectionLink(id: $id) {        
        ...AddressDataProtectionLink
    }
}
${ADDRESS_DATA_PROTECTION_LINK_FRAGMENT}
`;

export const GET_ADDRESS_DATA_PROTECTION_LINK_BY_ADDRESS_ID = gql`
query GetAddressDataProtectionLinkByAddressId($addressId:String!) {
    getAddressDataProtectionLinkByAddressId(addressId: $addressId) {
        ...AddressDataProtectionLinkWithoutAddress
    }
}
${ADDRESS_DATA_PROTECTION_LINK_WITHOUT_ADRESS_FRAGMENT}
`;

export const SAVE_ADDRESS_DATA_PROTECTION_LINK = gql`
mutation SaveAddressDataProtectionLink($input: AddressDataProtectionLinkInput!) {
    saveAddressDataProtectionLink(input: $input) {
        ...AddressDataProtectionLink
    }
}
${ADDRESS_DATA_PROTECTION_LINK_FRAGMENT}
`;

export const DELETE_ADDRESS_DATA_PROTECTION_LINK = gql`
mutation DeleteAddressDataProtectionLink($id: String!) {
    deleteAddressDataProtectionLink(id: $id) {
        ... DeletionResponse
    }
}
${DELETION_RESPONSE_FRAGMENT}
`;
// endregion

// region Contact Data Protection Link
export const CONTACT_DATA_PROTECTION_LINK_FRAGMENT = gql`
fragment ContactDataProtectionLink on ContactDataProtectionLink {
    ...IBaseModel
    contactId
    contact {
        ...ContactFields
    }
    dataProtectionId
    dataProtection {
        ...DataProtection
    }
}
${BASEMODEL_FRAGMENT}
${CONTACT_FIELDS_FRAGMENT}    
${DATA_PROTECTION_FRAGMENT}
`;

export const GET_CONTACT_DATA_PROTECTION_LINKS = gql`    
query GetContactDataProtectionLinks($input:SearchInput) {
    getContactDataProtectionLinks(input: $input) {
        totalItems
        items {
            ...ContactDataProtectionLink
        }
    }
}
${CONTACT_DATA_PROTECTION_LINK_FRAGMENT}
`;

export const GET_CONTACT_DATA_PROTECTION_LINK = gql`
query GetContactDataProtectionLink($id:String!) {
    getContactDataProtectionLink(id: $id) {
        ...ContactDataProtectionLink
    }
}
${CONTACT_DATA_PROTECTION_LINK_FRAGMENT}
`;

export const GET_CONTACT_DATA_PROTECTION_LINK_BY_CONTACT_ID = gql`
query GetContactDataProtectionLinkByContactId($contactId:String!) {
    getContactDataProtectionLinkByContactId(contactId: $contactId) {
        ...ContactDataProtectionLink
    }
}
${CONTACT_DATA_PROTECTION_LINK_FRAGMENT}
`;

export const SAVE_CONTACT_DATA_PROTECTION_LINK = gql`
mutation SaveContactDataProtectionLink($input: ContactDataProtectionLinkInput!) {
    saveContactDataProtectionLink(input: $input) {
        ...ContactDataProtectionLink
    }
}
${CONTACT_DATA_PROTECTION_LINK_FRAGMENT}
`;

export const DELETE_CONTACT_DATA_PROTECTION_LINK = gql`
mutation DeleteContactDataProtectionLink($id: String!) {
    deleteContactDataProtectionLink(id: $id) {
        ... DeletionResponse
    }
}
${DELETION_RESPONSE_FRAGMENT}
`;

export const ADD_DATA_PROTECTION_ASSETS = gql`
mutation AddDataProtectionAssets($id: String!, $assetIds: [String!]!) {
    addDataProtectionAssets(id: $id, assetIds: $assetIds)
}
`;
// endregion